import { $Q, $Qll } from "./query-selector"

const changeTypeInput = (input) => {
  const value = input.type === "password" ? "text" : "password";
  input.setAttribute("type", value);
}

const applyLineNone = (eyeContent, input) => {
  const isShow = input.type === "password";

  if (!isShow) {
    eyeContent.classList.add("eye-none");
    return;
  }
  eyeContent.classList.remove("eye-none");

}

export const showPassword = () => {
  const showsEyes = $Qll('.show-password');

  showsEyes.forEach((eye) => {
    eye.addEventListener("click", () => {
      const input = $Q('input', eye.closest(".form__textfield"));
      const eyeContent = $Q('.line-none', eye.closest(".form__textfield"));
      changeTypeInput(input);
      applyLineNone(eyeContent, input);
    })
  })
}
